export const PERSON_TYPE = 2
export const FUEL_REQUEST_END = 2
export const FUEL_REQUEST_LOCAL = 2
export const MAP_TYPE_MAPGL = 'Mapgl'
export const FUEL_REQUEST_CANCEL = 3
export const FUEL_REQUEST_DURING = 1
export const FUEL_REQUEST_ONLINE = 1
export const PAYMENT_TYPE_CREDIT = 1
export const PAYMENT_TYPE_CASH = 0
export const PAYMENT_TYPE_POS = 2
export const PAYMENT_TYPE_VALINA = 3
export const FUEL_REQUEST_ORGANIZATION = 3
export const MAP_TYPE_PARSIMAP = 'Parsimap'
export const FUEL_REQUEST_VOLUME_CONFIRM = 4
export const MAP_CONFIG = 'mapConfig_operator'
export const MY_IP = 'myip'
export const FUEL_REQUEST_CANCEL_BY_ADMIN = 4
export const FUEL_REQUEST_OPERATOR_REFUELING = 1
export const FUEL_REQUEST_ONLINE_OPERATOR_ON_WAY = 0
export const AUTHORIZATION = 'accessToken_Operator'
export const REQUEST_DETAILS_TYPE = 'OperatorInProcess'
export const FUEL_REQUEST_INPROCESS_TYPE_LIST = 'List'
export const FUEL_REQUEST_INPROCESS_TYPE_COUNT = 'Count'
export const BLANK_PAGE_FINANCIAL = 'BLANK_PAGE_FINANCIAL'
export const BLANK_PAGE_INCENTIVE = 'BLANK_PAGE_INCENTIVE'
export const MAP_LOCATION_DEFAULT = 'MAP_LOCATION_DEFAULT'
export const FUEL_REQUEST_INPROCESS_TYPE_FIRST = 'FirstRequest'
export const MAP_LOCATION_CAR_ONLINE = 'MAP_LOCATION_CAR_ONLINE'
export const BLANK_PAGE_CAR_REPAIR = 'BLANK_PAGE_CAR_REPAIR'
export const BLANK_PAGE_REFUELING_TANKER = 'BLANK_PAGE_REFUELING_TANKER'
export const BLANK_PAGE_FUEL_REQUEST_LOCAL = 'BLANK_PAGE_FUEL_REQUEST_LOCAL'
export const BLANK_PAGE_FUEL_REQUEST_ONLINE = 'BLANK_PAGE_FUEL_REQUEST_ONLINE'
export const BLANK_PAGE_FUEL_REQUEST_RESERVE = 'BLANK_PAGE_FUEL_REQUEST_RESERVE'
export const BLANK_PAGE_FUEL_REQUEST_ORGANIZATION = 'BLANK_PAGE_FUEL_REQUEST_ORGANIZATION'